import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Widget } from 'src/app/models/Widget';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserWidgetService {
  private http = inject(HttpClient);

  createUserDashboard(widgets: Widget[]): Observable<Widget[]> {
    return this.http.post<Widget[]>(
      `${environment.apiUrl}/user-widgets/create-user-dashboard`,
      widgets
    );
  }

  getUserDashboard(): Observable<Widget[]> {
    return this.http.get<Widget[]>(
      `${environment.apiUrl}/user-widgets/get-user-dashboard`
    );
  }
}
